export default "__VITE_ASSET__B3QTv$3v__"